import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, LabelList } from 'recharts';
import PropTypes from 'prop-types';
import * as styles from './bar-chart-card.module.scss';
import { TA_TENURE_TABS } from '../../talent-analytics.constant';
import { isEmpty } from 'lodash';

const BarChartCard = (props) => {
  const { data, onViewReport, chartType, maxEntryItem } = props;

  const getMaxEntryVal = useMemo(() => {
    return maxEntryItem?.value
      ? Number(maxEntryItem?.value) > 10000
        ? Number(maxEntryItem?.value) + 10000
        : (Number(maxEntryItem?.value) > 1000 ? Number(maxEntryItem?.value) + 2000 : Number(maxEntryItem?.value)) + 100
      : 20000;
  }, [maxEntryItem]);

  return (
    <div
      className={`${styles.wrapper} chartWrapCustom`}
      style={[TA_TENURE_TABS[2]].includes(chartType) ? { borderRadius: '12px' } : { borderRadius: '6px' }}
    >
      {[TA_TENURE_TABS[2], TA_TENURE_TABS[4]].includes(chartType) && (
        <div className={styles.chart_info}>
          <div className={styles.chart_no}>{data?.no || ''}</div>
          <div className={styles.chart_range}>{data?.name || ''}</div>
          <div className={styles.chart_sub_total}>{data?.count || 0}</div>
        </div>
      )}
      <button className={styles.btn} onClick={onViewReport}>
        View report
      </button>

      {chartType && [TA_TENURE_TABS[2], TA_TENURE_TABS[4]].includes(chartType) ? (
        <ResponsiveContainer width={399} height={221}>
          <BarChart layout="vertical" data={!isEmpty(data?.values) && data.values.filter((i) => i?.value !== 0)} barSize={23} stackOffset="sign">
            <XAxis type="number" hide domain={[0, getMaxEntryVal]} />
            <YAxis
              type="category"
              dataKey="name"
              fontSize={12}
              color="#5D7083"
              tickLine={false}
              axisLine={false}
              width={TA_TENURE_TABS[4] === chartType ? 120 : 200}
              tick={{ textAnchor: 'end', dx: -10 }}
            />
            <Bar dataKey="value" stackId="center" fill="#00A19C" radius={4}>
              <LabelList dataKey="value" position="right" fill="#000" fontSize={12} fontWeight={500} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <ResponsiveContainer width="100%" height={450}>
          <BarChart data={data} barSize={36}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="name" tickLine={false} axisLine={false} fontSize={14} color="#4F5F6E" tick={<CustomTick />} />
            <YAxis tickLine={false} axisLine={false} domain={[0, 'auto']} fontSize={14} color="#4F5F6E" />
            <Bar dataKey="value" fill="#00A19C" radius={4}>
              <LabelList dataKey="value" position="top" fill="#000" fontSize={12} fontWeight={500} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default BarChartCard;

BarChartCard.propTypes = {
  data: PropTypes.array,
  onViewReport: PropTypes.func,
};

const CustomTick = (props) => {
  const { x, y, payload } = props;

  const width = 30;
  const height = 20;

  return (
    <g transform={`translate(${x - 16}, ${y})`}>
      <rect width={width} height={height} fill="#F0F5FA" rx={10} ry={10} />
      <text x={width / 2} y={height / 2 + 4} textAnchor="middle" fill="#4F5F6E" fontSize={12} fontWeight={500}>
        {payload.value}
      </text>
    </g>
  );
};
